<template>
    <div>
        <van-popup
                position="bottom"
                @click-overlay="onClose"
                :close-on-click-overlay="false"
                v-model="payShow"
        >
            <div class="topay-content-wrap">
                <h3 class="title">在线支付</h3>
                <p class="total-price">¥{{price}}</p>
                <label v-for="(item,index) in types" class="pay-item">
                    <input type="radio" name="type" :value="item.type" v-model="selectedPayType"
                           :disabled="item.disabled"><!--   :checked="item.type=='weixin'"-->
                    <div class="pay-item-content flex-wrap flex-valign-center">
                        <div :class="['icon', 'icon-'+item.type]"></div>
                        <div class="inner-content flex-item-1">
                            <p class="sub-title">{{item.name}}</p>
                            <p class="sub-tip">{{item.des}}</p>
                        </div>
                    </div>
                </label>
                <div class="pay-item-content flex-wrap flex-valign-center"
                     v-if="selectedPayType == 'balance'  && havePayPassword==true">
                    <div class="flex-item-1" style="margin: 10px auto; width: 90%  ">
                        <input v-model="password"
                               style="letter-spacing: 1em ;font-size: 14px; width: 100% ; border: 1px solid #eee; border-radius: 6px; padding: 6px;  text-align: center ;"
                               maxlength="6" type="password"
                               placeholder="请输入支付密码">
                    </div>
                </div>
                <div class="pay-item-content flex-wrap flex-valign-center"
                     v-if="selectedPayType == 'balance'  && havePayPassword==false">
                    <div class="flex-item-1" style="margin: 10px auto; width: 90%  ">
                        <input v-model="password"
                               style="letter-spacing: 1em ;font-size: 14px; width: 100% ; border: 1px solid #eee; border-radius: 6px; padding: 6px;  text-align: center ;"
                               maxlength="6" type="password"
                               placeholder="请设置支付密码">
                    </div>
                </div>
                <div class="pay-item-content flex-wrap flex-valign-center"
                     v-if="selectedPayType == 'balance' && havePayPassword==false" style="margin-top: -20px">
                    <div class="flex-item-1" style="margin: 10px auto; width: 90%  ">
                        <input v-model="password2"
                               style="letter-spacing: 1em ;font-size: 14px; width: 100% ; border: 1px solid #eee; border-radius: 6px; padding: 6px;  text-align: center ;"
                               maxlength="6" type="password"
                               placeholder="请再次输入支付密码">
                    </div>
                </div>
                <div class="btn-wrap">
                    <van-button type="primary" style="width: 100%" @click.stop="toPay">立即支付</van-button>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<style scoped>
    .topay-content-wrap {

        width: 100%;
        min-height: 30px;
        color: #333;
        background-color: #fff;
    }

    .topay-content-wrap .title {
        text-align: center;
        font-size: 17px;
        font-weight: normal;
        line-height: 50px;
    }

    .topay-content-wrap .title:after {
        content: '';
        position: absolute;
        left: 0;
        right: 0;
        bottom: 0;
        border-bottom: 1px solid #d9d9d9;
        transform: scaleY(0.5);
    }

    .topay-content-wrap .total-price {
        padding: 24px 0 4px;
        text-align: center;
        font-size: 33px;
        font-weight: normal;
        line-height: 1.2;
    }

    .topay-content-wrap .pay-item {
        position: relative;
        display: block;
    }

    .topay-content-wrap .pay-item:not(:last-child):after {
        content: '';
        position: absolute;
        left: 64px;
        right: 15px;
        bottom: 0;
        border-bottom: 1px solid #d9d9d9;
        transform: scaleY(0.5);
    }

    .topay-content-wrap .pay-item input {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        opacity: 0;
        border: 0;
        -webkit-appearance: none;
    }

    .topay-content-wrap .pay-item input:checked + .pay-item-content:after {
        display: block;
        content: "";
        width: 14px;
        height: 10px;
        margin: 0 15px;
        background-image: url("../assets/images/radio-checked.png");
        background-size: 14px 10px;
        position: center;
        background-repeat: no-repeat;
    }

    .topay-content-wrap .pay-item input:disabled + .pay-item-content {
        opacity: 0.5;
    }

    .topay-content-wrap .pay-item-content {
        padding: 8px 15px;
    }

    .topay-content-wrap .pay-item-content .icon {
        margin-right: 15px;
        width: 32px;
        height: 32px;
        background-repeat: no-repeat;
        background-size: 32px;
        background-position: center;
    }

    .topay-content-wrap .pay-item-content .icon.icon-balance {
        background-image: url("../assets/images/icon-wallet.png");
    }
    .topay-content-wrap .pay-item-content .icon.icon-gongwuka {
        background-image: url("../assets/images/icon-wallet.png");
    }

    .topay-content-wrap .pay-item-content .icon.icon-weixin {
        background-image: url("../assets/images/icon-weixin.png");
    }

    .topay-content-wrap .pay-item-content .icon.icon-weixinh5 {
        background-image: url("../assets/images/icon-weixin.png");
    }
    .topay-content-wrap .pay-item-content .icon.icon-weixinapp {
        background-image: url("../assets/images/icon-weixin.png");
    }
    .topay-content-wrap .pay-item-content .icon.icon-alipayapp {
        background-image: url("../assets/images/icon-alipay.png");
    }
    .topay-content-wrap .pay-item-content .icon.icon-alipayapp2 {
        background-image: url("../assets/images/icon-alipay.png");
    }

    .topay-content-wrap .pay-item-content .sub-title {
        font-size: 16px;
    }

    .topay-content-wrap .pay-item-content .sub-tip {
        font-size: 12px;
        color: #999;
        padding-top: 2px;
    }

    .btn-wrap {
        padding: 20px 15px 15px;
    }
</style>
<script>
    import {Popup, CellGroup, Cell, Switch ,Button,Dialog} from 'vant'

    export default {
        name: 'PayDialog',
        components: {
            [Popup.name]: Popup,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Switch.name]: Switch,
            [Button.name]: Button,
            [Dialog.name]: Dialog,
        },
        props: {
            show: {
                type: Boolean,
                default: false
            },
            ids: {
                type: Array,
                default() {
                    return []
                }
            },
            fromPage: {
                type: String,
                default() {
                    return ''
                }
            },
            scene: {
                type: String,
                default() {
                    return ''
                }
            },
        },
        data: function () {
            return {
                tt:{},
                selectedPayType: "",
                havePayPassword: false,
                isWrapShow: this.isShow,
                can_submit: true,
                price: "",
                password: "",
                password2: "",
                types: [],
                list: [],
                payShow: false
            }
        },
        watch: {
            show(val) {
//        console.log('showchange');
                this.payShow = val
                if (val) {
                    var that = this;


                    if (that.ids.length == 0) {
                        //0元 免支付
                        that.onPaySuccess();
                        return;
                    }
                    if (that.ids && that.ids.length > 0) {
                        var params = {
                            ids: that.ids,
                            scene:that.scene
                        }

                        this.$api.post('/api/order/getOrderPayTypes', params, r => {
                            //获取支付方式
                            that.price = r.data.pay.price;
                            that.types = r.data.pay.types;
                            that.list = r.data.list;
                            that.selectedPayType = r.data.selectedPayType;
                            that.havePayPassword = r.data.havePayPassword;

                        });
                    }
                }
            }
        },
        mounted: function () {
         this.$api.get('/api/weixin/jsConfig', {
             "url" : sessionStorage.getItem("wx_entry_url")
         }, r1 => {
             wx.config(r1.data);
             });
        },
        methods: {
            onClose() {
                this.$emit("onPayClose", {})
            },
            onPaySuccess() {
                this.$emit("onPaySuccess", {})
            },
            onPayError() {
                this.$emit("onPayError", {})
            },
            toPay() {
                if (this.can_submit == false) {
//              this.$toast.center('您已经提交过支付请求了!');
//              this.jump();
                    return;
                }
                this.can_submit = false;
                var that = this;
                let params = {
                    "orders": that.list,
                    "type": that.selectedPayType,
                    "password": that.password,
                    "password2": that.password2,
                };
                console.log('pay');
                that.$api.post('/api/order/orderpay', params, r2 => {
                    if (that.selectedPayType == 'weixin') {
                        //获取微信支付信息
                        wx.chooseWXPay({
                            timestamp: r2.data.data.timestamp,
                            nonceStr: r2.data.data.nonceStr,
                            package: r2.data.data.package,
                            signType: r2.data.data.signType,
                            paySign: r2.data.data.paySign,
                            success: function (res3) {
                                that.onPaySuccess();
                            },
                            cencel: function (res) {
                                console.log(res);
                                that.onPayError();
                            },
                            fail: function (res) {
                                console.log(res);
                                that.onPayError();
                            }
                        })
                    } else if (that.selectedPayType == 'weixinh5') {
                        location.href = r2.data.data.url;
                    } else if(that.selectedPayType == 'weixinapp'){
                        appEvent({
                            name: 'weixinAppPay',
                            query: r2.data.data
                        });
                        Dialog.setDefaultOptions({
                            'confirmButtonText':'支付成功',
                            'cancelButtonText':'支付失败',
                        })
                        Dialog.confirm({
                            title: '支付订单',
                            message: '请在微信中完成支付'
                        }).then(() => {
                            that.onPaySuccess();
                        }).catch(() => {
                            that.onPayError();
                        });
                    }else if(that.selectedPayType == 'alipayapp'){
    //                alert(r2.data.data);
                        appEvent({
                            name: 'alipayAppPay',
                            query: r2.data.data
                        });
                        Dialog.setDefaultOptions({
                            'confirmButtonText':'支付成功',
                            'cancelButtonText':'支付失败',
                        })
                        Dialog.confirm({
                            title: '支付订单',
                            message: '请在支付宝中完成支付'
                        }).then(() => {
                            that.onPaySuccess();
                        }).catch(() => {
                            that.onPayError();
                        });
    //                location.href= r2.data.data.url;
                    }else if(that.selectedPayType == 'alipayapp2'){
    //                alert(r2.data.data);
                        appEvent({
                            name: 'alipayAppPay',
                            query: r2.data.data
                        });
                        Dialog.setDefaultOptions({
                            'confirmButtonText':'支付成功',
                            'cancelButtonText':'支付失败',
                        })
                        Dialog.confirm({
                            title: '支付订单',
                            message: '请在支付宝中完成支付'
                        }).then(() => {
                            that.onPaySuccess();
                        }).catch(() => {
                            that.onPayError();
                        });
    //                location.href= r2.data.data.url;
                    }else {
                        that.onPaySuccess();
                    }
                }, r2 => {
                    that.$toast(r2.msg);
                    that.can_submit = true;
                    that.onPayError();
                });
            }
        }
    }
</script>



// WEBPACK FOOTER //
// PayDialog.vue?24dde46a